<template>
<div>
  <v-card>
    <v-card-title>
            Bitácora      
      <v-spacer></v-spacer>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="date"
            transition="scale-transition"
            offset-y
            min-width="290px"
            color="#7c167d"
          >
            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateRangeText"
                  label="Fecha consultar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
            </template>
          
            <v-date-picker v-model="dates" range no-title scrollable color="#7c167d">
              <v-spacer></v-spacer>
              <v-btn text color="#7c167d" @click="menu = false">Cancel</v-btn>
              <v-btn text color="#7c167d" @click="consultaBitacora()">OK</v-btn>
            </v-date-picker>
          </v-menu>
          <v-btn text color="#7c167d" @click="consultaBitacora()" :disabled="dates.length === 0 ? true : false">
            <v-icon> mdi-refresh</v-icon>
          </v-btn>
    </v-card-title>  
      <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Filter"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="jsonData"
      :items-per-page="5"
      class="elevation-1"
      :search="search"
      :sort-by="['fecha']"
      :sort-desc="[true]"
    >
      <template v-slot:item="row">
          <tr>
            <td>{{row.item.fecha | formatDate}}</td>
            <td>{{row.item.rut}}</td>
            <td>{{row.item.patente}}</td>
            <td>{{row.item.modulo}}</td>
            <td>{{row.item.accion}}</td>
            <td>
                <v-btn class="mx-2" fab dark small color="pink" @click="onButtonClick(row.item.request, 'Request')">
                  <v-icon dark>mdi-chevron-double-up</v-icon>
                </v-btn>
            </td>
            <td>
                <v-btn class="mx-2" fab dark small @click="onButtonClick(row.item.response, 'Response')">
                    <v-icon>mdi-chevron-double-down</v-icon>
                </v-btn>
            </td>
          </tr>
      </template>
      
    </v-data-table>

    <v-dialog
      v-model="dialog"
      width="1000px"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          {{cardTitle}}  
        </v-card-title>

        <v-card-text> 
          <vue-blob-json-csv
            file-type="json"
            file-name="archivo"
            :data="[cardText]"
          >
            <div class="pa-2 d-flex justify-end">
            <v-btn text small icon outlined color="indigo">
              <v-icon>mdi-download</v-icon> 
            </v-btn>
           </div> 
          </vue-blob-json-csv>
          <json-viewer
              :value="cardText"
              :expand-depth=2
              :copyable="{copyText: 'copiar', copiedText: 'copiado', timeout: 10000}"
              expanded
              >            
              </json-viewer>
        </v-card-text>
      </v-card>  
    </v-dialog>
  </v-card>
  <template>
          <div class="vld-parent">
              <loading :active.sync="isLoading"
              :is-full-page="fullPage"></loading>
          </div>
    </template>
</div>
</template>

<script>
import axios from "axios";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';  
import moment from 'moment';

import {api_url} from '../config/index';
       

export default {
    data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      modal: false,
      menu2: false,

      dates: [],
      picker: new Date().toISOString().substr(0, 10),
      fullPage: true, 
      isLoading: false,
      search: '',
      dialog: false,
      cardTitle: '',
      cardText: '',
      jsonData: [],
      headers: [
          {
            text: 'Fecha',
            align: 'start',
            value: 'fecha',
          },
          { text: 'Rut Asegurado', value: 'rut' },
          { text: 'Patente', value: 'patente' },
          { text: 'Modulo', value: 'modulo' },
          { text: 'Acción', value: 'accion' },
          { text: 'Request', value: 'request' },
          { text: 'Response', value: 'response' },

        ]
    }
  },
  filters: {
    formatDate:
      function(date){
        return moment(date).format("DD-MM-YYYY h:mm:ss");
    }
  },
  created() {      
    //this.loadData();
  },
  components : {
      Loading,
  },
  computed: {
      dateRangeText () {
        return this.dates.join(' ~ ')
      },
    },
  methods: {
      async loadData(fechaDesde, fechaHasta){               
          this.isLoading = true;
          await axios.get(`${api_url}/bitacora?fechaDesde=${fechaDesde}&fechaHasta=${fechaHasta}`, {
            headers: {
              'user_token': sessionStorage.getItem('token')
            }
          })
                  .then((response) => {                 
                    let data = response.data;
                    if (data.error) {
                      this.$swal(
                        'Error!',
                        data.error,
                        'error'
                      )
                      return this.jsonData = [];
                    }
                    this.jsonData = data;       

                  })
                  .catch((err) => {
                    console.log(err);
                  });          
          this.isLoading = false;
      },
      onButtonClick: function (item, title) {
        console.log('onButtonClick');
        console.log(item);
        this.cardTitle = title;
        this.cardText = item;
        this.dialog = true;
      }, 
      consultaBitacora() {
        this.menu = false;
        this.loadData( this.dates[0], this.dates[1] );
      }
    }
}
</script>
